import React        from 'react';
import _ from 'lodash';
const marshalProps = (props,context) => {
  let marshalled = Object.assign({svgwidth:props.width,svgheight:props.height}, props);
  if(typeof props.width === "string" && props.width.indexOf("%")>=0) {
      let wpct = parseInt(props.width)/100;
      marshalled.width = context.containerWidth? wpct*context.containerWidth : null;
  }

  if(typeof props.height === "string" && props.height.indexOf("%")>=0) {
      let hpct = parseInt(props.height)/100;
      marshalled.height = context.containerHeight? hpct*context.containerHeight : null;
  } else if(typeof props.height === "string" && props.height.indexOf('w')>=0) {
      marshalled.height = context.containerWidth? parseFloat(props.height) * context.containerWidth : null;
      marshalled.svgheight = marshalled.height;
  }
  return marshalled;
};
export default class SVGChart extends React.Component {
    constructor(props,context) {
        super(props,context);    
    }
    render() {
        const d3Props = marshalProps(this.props,this.context);
        const childrenWithProps = React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, Object.assign({},d3Props,child.props));
        });
        
        if(d3Props.height && d3Props.width) {
            return <div ref="svgcontainer"><svg ref="svgcanvas" width={d3Props.svgwidth} height={d3Props.svgheight}>
                {childrenWithProps}
            </svg></div>
        } else {
            return <div ref="svgcontainer"><svg ref="svgcanvas" width={d3Props.svgwidth} height={d3Props.svgheight}></svg></div>
        }
    }
}

SVGChart.contextTypes = {
    containerWidth: React.PropTypes.number,
    containerHeight: React.PropTypes.number
};




// WEBPACK FOOTER //
// ./src/js/components/charting/SVGChart/SVGChart.jsx